module.exports = __webpack_public_path__ + "img/course7.1be7938a.png";